// LA BARRE EN PILULE : des onglets dans une piste arrondie, l'actif en relief.
//
// Sortie de PreviewDataToggle (Preview / Files / Data…) pour que la page d'accueil emploie la même,
// et pas une copie qui dériverait. Le dessin est inchangé, classe pour classe.

export function PillTabs<T extends string>({ items, value, onChange, label }: {
  items:    readonly (readonly [T, string])[];
  value:    T;
  onChange: (v: T) => void;
  label?:   string;
}) {
  return (
    <div aria-label={label} className="no-scrollbar inline-flex min-w-0 max-w-full items-center gap-0.5 overflow-x-auto rounded-full border border-border bg-surface-muted/60 p-0.5 shadow-[inset_0_1px_2px_rgba(0,0,0,0.08)]">
      {items.map(([id, text]) => {
        const active = value === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            aria-pressed={active}
            className={
              "shrink-0 whitespace-nowrap rounded-full px-3.5 py-1 text-[11px] font-semibold uppercase tracking-wider transition " +
              (active
                ? "bg-surface text-text shadow-[var(--shadow-raised)]"
                : "text-text-secondary hover:text-text")
            }
          >
            {text}
          </button>
        );
      })}
    </div>
  );
}
